// Optional nicknames shown next to player names everywhere on the site.
// Names must match rounds.js exactly. Add or remove entries freely.
export const NICKNAMES = {
  "Ed Hascup": "The Mayor",
  "Scott Lewis": "Mr. Happy",
  "Troy Ham": "Captain",
  "Jeremy Ducharme": "Magic Man",
  "Ric Buesgen": "PeePaw",
  "Clint Birch": "The Gold Jacket",
};

export const displayName = (name) => (NICKNAMES[name] ? `${name} (${NICKNAMES[name]})` : name);
